import { Component, Input, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/modules/gasprecio/services/shared.service';

@Component({
  selector: 'app-select-product-dashboard2',
  templateUrl: './select-product-dashboard2.component.html',
  styleUrls: ['./select-product-dashboard2.component.scss']
})
export class SelectProductDashboard2Component implements  OnDestroy {

  public items: any[] = [
    { name: 'Total', value: 'total' },
    { name: 'Regular', value: 'regular' },
    { name: 'Premium', value: 'premium' },
    { name: 'Diesel', value: 'diesel' }
  ];

  public productTypeTotal: any = [];
  public ngxDisabled = false;
  productTypeTotal$: Subscription;

  constructor(
    public sanitizer: DomSanitizer,
    private sharedService: SharedService
  ) {
    this.productTypeTotal$ = this.sharedService.sharedProductTypeDashboard2.subscribe(productTypeTotal => {
      if (this.productTypeTotal !== productTypeTotal) {
        this.productTypeTotal = productTypeTotal;
      }
    });
  }

  public style(data: string): SafeStyle {
    return this.sanitizer.bypassSecurityTrustStyle(data);
  }

  ngOnInit() {
    this.items = [
      { name: 'Total', value: 'total' },
      { name: 'Regular', value: 'regular' },
      { name: 'Premium', value: 'premium' },
      { name: 'Diesel', value: 'diesel' }
    ];
  }

  ngOnDestroy() {
    this.productTypeTotal$.unsubscribe();
  }

  changeProductType(event: any) {
    this.productTypeTotal = event;
    this.sharedService.nextProductTypeproductTypeDashboard2 = this.productTypeTotal;
  }
}